import { ReactNode } from 'react';

import { TooltipProvider } from '@/ux-common/components/tooltip/tooltip';

import { TABLE_TOOLTIP_DELAY_MS } from './constants';

/**
 * An "island" is a subtree that overrides the app root's tooltip timing.
 * The app is instant everywhere (UX-3107 — see app-providers.tsx); inside an
 * island, hovering waits TABLE_TOOLTIP_DELAY_MS before a tooltip opens, so
 * sweeping the pointer across dense rows does not fire a tooltip per cell.
 * Outside the subtree nothing changes — hence island: a bounded region with
 * its own timing, in a sea of instant.
 *
 * Every data grid mounts one. DataTableRoot wraps itself in it; a legacy
 * useDataTable grid whose cells render bare tooltips mounts its own. Keeping
 * the assembly here means an island cannot be put together inconsistently,
 * and the useDataTable-migration teardown is a one-symbol find-usages.
 *
 * Cells must not pin their own delayDuration — they inherit the island's.
 */
export const TableTooltipIsland = ({ children }: { children: ReactNode }) => (
  <TooltipProvider delayDuration={TABLE_TOOLTIP_DELAY_MS}>{children}</TooltipProvider>
);
